import * as React from 'react';
import { App } from '../components/App';
import { LoginPage } from './LoginPage';
import { useAuth, useData } from '../core/context/ProvidersContext';
import { setProductsConfig } from '../components/shared/ProductColors';

export const StandaloneApp: React.FC = () => {
  const { user, loading, refresh } = useAuth();
  const data = useData();

  // Load remote products config once at startup so all components see the colors.
  React.useEffect(() => {
    data.getProductsConfig()
      .then(setProductsConfig)
      .catch(() => { /* keep defaults */ });
  }, [data]);

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: '#F5F6F8', fontFamily: 'DM Sans, Segoe UI, sans-serif', color: '#6a737d',
      }}>
        Chargement…
      </div>
    );
  }

  if (!user) return <LoginPage onLoginSuccess={refresh} />;

  return <App />;
};
